<template>
  <div class="pa-3">
    <v-data-table
      class="questionnaire-table mt-6"
      hide-default-footer
      disable-sort
      :headers="headers"
      :items="roomAnswers"
      :itemsPerPage="-1"
      :mobile-breakpoint="0"
    >
      <template v-slot:item.name="{ item }">
        <div class="participant-name">
          <icon-base icon="campaigns/person" alt="" class="mr-2" />
          {{ item.name }}
        </div>
      </template>

      <template v-slot:item.answers="{ item }">
        <v-chip
          v-for="(answer, idx) in getPersonAnswers(item)"
          color="primary"
          text-color="white"
          :key="idx"
          class="mr-2"
          @click="showAnswer(item, answer.key)"
          >{{ answer.title }}</v-chip
        >
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { eventBus } from '@/lib/events';
import { mapState } from 'vuex';

export default {
  name: 'QuestionnaireAnswersTable',
  data() {
    return {
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: true,
        },
        {
          text: 'Answers',
          value: 'answers',
          sortable: true,
        },
      ],
    };
  },
  computed: {
    ...mapState('rooms', ['questionnaireAnswers', 'roomInfo']),
    roomAnswers() {
      return this.questionnaireAnswers.filter(({ room }) => {
        return this.isAnswerBelongsToCurrentRoom(room);
      });
    },
    currentRoom() {
      return this.getRoomRoot(this.roomInfo?.room);
    },
  },
  methods: {
    isAnswerBelongsToCurrentRoom(room) {
      return !room || this.getRoomRoot(room) === this.currentRoom;
    },
    getRoomRoot(roomName) {
      return (roomName || '').split('-breakout')[0];
    },
    showAnswer(answer, key) {
      eventBus.trigger('showParticipantAnswers', {
        participantId: answer.identity,
        key,
      });
    },
    getPersonAnswers(record) {
      return (record?.answers || []).slice().sort((a, b) => {
        return (b?.key || '').localeCompare(a?.key || '');
      });
    },
  },
};
</script>

<style lang="less">
.participant-name {
  font-weight: 600;
  color: var(--v-appMain-base);

  svg {
    height: 24px;
    width: 24px;
  }
}

.v-data-table.questionnaire-table {
  border: 2px solid #e6e7e9;

  tbody {
    tr:not(.v-row-group__header) {
      height: 56px;
      cursor: pointer;
    }
  }
}

.quest-answer {
  cursor: pointer;
}

.info-list {
  margin: 16px -8px 0;
  &__item {
    padding: 10px 24px;
    min-height: 56px;
    background-color: #fff;
    &:nth-child(odd) {
      background-color: #f7f7f7;
    }
    &:last-child {
      border-bottom: 2px solid #f2f2f3;
    }
    &-title {
      font-weight: bold;
      font-size: 16px;
      line-height: 1.25;
      color: var(--v-appMain-base);
      margin-bottom: 12px;
    }
    &-value {
      font-weight: 600;
      font-size: 14px;
    }
  }
}
</style>
